<template>
  <div>
    <span class="titleTOP">{{t('手机登录')}}</span>
    <div class="divAccount">
      <img src="../../../assets/img/account.png" class="icon">
      <input ref="phone" type="text" value="" class="username" :placeholder="t('请输入手机号')">
    </div>
    <div class="divCode">
      <img src="../../../assets/img/password.png" class="icon">
      <input ref="sendcode" value="" class="pwd code" :placeholder="t('请输入短信验证码')">
      <Button
              class="erCodeBtn"
              :disabled="sended"
              @click="sendErCode"
      >{{ btnTips === 1 ? t('获取验证码') : `${t('重新获取')}${this.count}s`}}</Button>
    </div>
    <div class="divToggle" v-if="loginType">
      <span class="sanjiao">
        <img src="../../../assets/img/home.png" class="toggle home" @click="toggles">
      </span>
    </div>
  </div>
</template>

<script>
  // import network from '../../__utils__/network';
  // import {enableGateWay} from '../../constants/global';
import { enableGateWay } from './login.config';

  export default {
    name: 'PhoneLogin',
    props: {
      loginType: {
        type: Boolean,
        default: false
      },
      TypeToggle: {
        type: Number,
        default: 1
      },
      phoneExp: {
        type: RegExp
      },
    },
    data() {
      return {
        btnTips: 1,
        sended: false,
        timer: null,
        count: 0,
      }
    },
    mounted() {
      this.fillLastPhone();
    },
    activated() {
      this.fillLastPhone();
    },
    methods: {
      fillLastPhone() {
        const phone = window.localStorage.getItem('lastLoginPhone');
        const input = this.$refs.phone;
        if (phone && input && !input.value) {
          input.value = phone;
        }
      },
      login() {
        this.$parent.login()
      },
      toggles() {
        this.$emit('toggle', 1)
      },
      async sendErCode() {
        const phoneNo = this.$refs.phone.value;
        if (!(this.phoneExp.test(phoneNo))) return this.$Modal.fcError({
          title: t('错误'),
          content: t('请输入正确的手机号')
        });
        const code = await this.getMessageCode(phoneNo);
        if (!code.data || code.data.code !== 0) return false;
        this.sended = true;
        this.count = 59;
        this.setTimer();
        this.$Message.success(t('获取验证码成功'));
      },
      setTimer() {
        this.timer = setTimeout(() => {
          this.count--;
          if (this.count === 0) {
            this.timer && clearTimeout(this.timer);
            this.timer = null;
            this.btnTips = 1;
            this.sended = false;
          } else {
            this.btnTips = 2;
            this.setTimer();
          }
        }, 1000);
      },

      // 手机登录验证码获取
      getMessageCode(phoneNo) {
        const globalServiceId = this.$parent.globalServiceId;
        return new Promise(resolve => {
          const param = new FormData()
          param.append('phone', phoneNo)
          this.service.common.publicUrlParams(enableGateWay() ? `/${globalServiceId}/p/c/verificationCode` : '/p/c/verificationCode', param).then(r => resolve(r))
        })
      },
    }
  }

</script>
